import { Component, Inject, OnInit } from '@angular/core';
import { AppService } from '@cigna/cigna-for-brokers/shared/data-access';
import {
  GatewayConfig,
  GATEWAY_CONFIG,
} from '@cigna/cigna-for-brokers/shared/gateways';
import { TranslateService } from '@ngx-translate/core';
import get from 'lodash/get';

/**
 * Shell for the screens a broker sees after authenticating but before entering the
 * portal proper, such as the credentials merge flow. The header matches the unsecure
 * one and no side navigation is shown, because the broker has not entered the portal
 * yet, but the footer is the secure one the broker sees once inside.
 */
@Component({
  selector: 'cigna-layout-presecure',
  templateUrl: './layout-presecure.component.html',
  styleUrls: ['./layout-presecure.component.scss'],
})
export class LayoutPreSecureComponent implements OnInit {
  envName = '';
  /** Swaps the footer's broker terms, same as the secure layout. */
  isDivestEnabled = false;

  constructor(
    private _appService: AppService,
    private translate: TranslateService,
    @Inject(GATEWAY_CONFIG) private _config: GatewayConfig,
  ) {}

  ngOnInit(): void {
    this._appService.setIntegrationOn(true);

    // get flag from resource bundle
    this.envName = this._config.environmentName;
    const featureFlagBase = this.translate.instant(`featureFlag`);

    const flagObj = get(featureFlagBase, this.envName);
    this.isDivestEnabled = get(flagObj, 'isDivestEnabled');
  }
}
